export const STRING = {
  // Button
  SUBMIT: 'Submit',
  CANCEL: 'Cancel',
  CONFIRM: 'Confirm',
  CLOSE: 'Close',

  // LogIn & Register screen
  PWD_LABEL: 'Password',
  EMAIL_LABEL: 'Email',
  FORGET_PWD: 'Forgot password?',
  SING_IN: 'Sign in',
  INVALID: 'This field is required',
  EMAIL_INVALID: 'Email format invalid',
  PHONE_INVALID: 'Phone format invalid',
  TAX_INVALID: 'Tax ID format invalid',
  NO_INVALID: 'No. of license user format invalid',
  TAX_CHECK: '*This Tax ID was been registerrd.',
  // Forget password screen
  FORGET_PWD_TITLE: 'Forgot Password',
  FORGET_YOUR_PWD: 'Forgot your password?',
  FORGET_PWD_DETAIL: `Please enter your email address and we will send you an email to reset password.`,

  // Home
  MY_SOURCING: 'My Sourcing Tasks',
  AMOUNT: 'AMOUNT',
  CHANGE_RATE: 'CHANGE RATE',

  // Supplier Discovery
  SUPPLIER_DISCOVERY: 'Supplier Discovery',
  HOME: 'Home',
  BUSINESS_CATEGORY: 'Business Category',
  BUSINESS_TYPE: 'Business Type',
  REGISTERED_CAPITAL: 'Registered Capital',
  YEAR_ESTABLISHED: 'Year Established',
  FINANCIAL_RISK: 'Financial Risk',
  FINANCIAL: 'Financial',
  OPERATIONAL: 'Operational',
  REGULATORY: 'Regulatory',
  ESG_SCORE: 'ESG Score',
  SS_RISK: 'Sustainability Risk',
  SS_SCORE: 'Sustainability Pre-Assessment',
  RISK_LEVEL: 'Risk Level',
  SCORE_SS: 'Score (SS)',
  MY_SUPPLIER: 'My Supplier',
  MAIN_DIRECTORY: 'Main Directory',
  TOTAL_SUPPLIER: 'Total Supplier',
  SORT_BY: 'Sort By',
  FILTER: 'Filter',
  ESG: 'ESG',
  TAX_ID: 'Tax ID',
  SERVICE_CATEGORY: 'Categories',
  THB: 'THB',
  NA: 'N/A',
  NEWS: 'News',
  ONLINE_COMPREHENSIVE: 'Online Comprehensive',
  ONLINE_COMPREHENSIVE_ASSESSMENT: 'Online Comprehensive Assessment',
  OFFLINE_COMPREHENSIVE: 'Offline Comprehensive',
  OFFLINE_COMPREHENSIVE_ASSESSMENT: 'Offline Comprehensive Assessment',
  ASSESSMENT: 'Assessment',
  REGULATORY_RISK: 'Regulatory Risk',

  // Supplier Discovery Info
  SUPPLIER_INFO: 'Supplier Information',
  COMPANY_NAME: 'Company Name',
  REGIS_ADDRESS: 'Registered Address',
  BRANCH: 'Branch',
  STATUS: 'Status',
  CONTACT_ADDRESS: 'Contact Address',
  PHONE: 'Phone',
  ATTACHMENT: 'Attachment',
  FAX: 'Fax',
  WEBSITE: 'Website',
  CONTACT_PERSON: 'Contact Person',
  TAG_RELEVANT: 'Tag Relevant',
  FINANCIAL_SCORE: 'Financial Risk',
  SUSTAINABILITY: 'Sustainability Management',
  EARNING_STATEMENT: 'Earning Statement',
  FINANCIAL_STATEMENT: 'Financial Statement',
  RATIO_FINANCIAL_STATEMENT: 'Ratio of Financial Statement',
  OPERATION_RISK: 'Operational Risk',
  COUNTRY: 'Country',
  // Financial Statement
  UNIT_THB: 'Unit THB',
  STATEMENT_OF_FINANCIAL: 'Statement of Financial Position',
  ACCOUNTS_RECEIVABLE: 'Accounts Receivable',
  INVENTORIES: 'Inventories',
  TOTAL_CURRENT_ASSETS: 'Total Current Assets',
  PROPERTY_PLANT: 'Property, Plant and Equipment',
  TOTAL_NONCURRENT: 'Total Non-current Assets',
  TOTAL_ASSETS: 'Total Assets',
  TOTAL_CURRENT_LIABILITIES: 'Total Current Liabilities',
  TOTAL_NONCURRENT_LIABILITIES: 'Total Non-current Liabilities',
  TOTAL_LIABILITIES: 'Total Liabilities',
  EQUITY: 'Equity',
  TOTAL_LIABILITIES_EQUITY: 'Total Liabilities and Equity',

  // Financial RatioTable
  NO: 'No',
  RATIO: 'Ratio',
  PROFITABILITY_RATIO: 'Profitability Ratio',
  RETURN_ON_ASSET: 'Return on Assets',
  RETURN_ON_EQUITY: 'Return on Equity',
  GROSS_PROFIT_MARGIN: 'Gross Profit Margin',
  OPERATING_PROFIT_MARGIN: 'Operating profit margin',
  NET_PROFIT_MARGIN: 'Net Profit Margin',
  OPERATING_EFFICIENCY_RATIO: 'Operation Efficiency Ratio',
  TOTAL_ASSETS_TURNOVER: 'Total Assets Turnover (times)',
  ACCOUNTS_RECEIVABLE_TURNOVER: 'Accounts Receivable Turnover (times)',
  INVENTORY_TURNOVER: 'Inventory Turnover (times)',
  OPERATING_EXPENSE_RATIO: 'Operation Expense to Total Revenue Ratio',
  LIQUIDITY_RATIO: 'Liquidity Ratio',
  CURRENT_RATIO: 'Current Ratio (times)',
  FINANCIAL_POSITION_RATIO: 'Financial Position Proportion Ratio',
  DEBIT_TO_RATIO: 'Debt to Asset Ratio (times)',
  ASSET_TO_EQUITY_RATIO: 'Asset to Equity Ratio or Financial Leverage (times)',
  DEBIT_TO_EQUITY_RATIO: 'Debt to Equity Ratio (times)',
  DEBT_ASSET: 'Debt to Asset Ratio (times)',
  DEBIT_TO_CAPITAL_RATIO: 'Debt to Capital Ratio (times)',

  //Earning Statement Table
  PROFIT_LOSS_STATEMENT: 'Profit and Loss Statement',
  REVENUE_SALES_SERVICES: 'Revenue from Sales & Services',
  TOTAL_REVENUE: 'Total Revenue',
  COST_OF_GOOD: 'Cost of Goods Sold',
  GROSS_PROFIT: 'Gross Profit (Loss)',
  SELLING_ADMIN_EXPENSES: 'Selling & Admin Expenses',
  TOTAL_EXPENSES: 'Total Expenses',
  INTEREST_EXPENSES: 'Interest Expenses',
  PROFIT_INCOME_TAX: 'Profit (Loss) before Income Tax',
  INCOME_TAX: 'Income Tax',
  NET_PROFIT: 'Net Profit (Loss)',

  //Buyer Management
  BUYER_MANAGEMENT: 'Buyer Management',

  //Supplier Management
  SUPPLIER_MANAGEMENT: 'Supplier Management',

  //User Management
  USER_MANAGEMENT: 'User Management',

  //Category Management
  CATEGORY_MANAGEMENT: 'Category Management',

  //Banner Management
  BANNER_MANAGEMENT: 'Banner Management',

  //Announcement Management
  ANNOUNCEMENT_MANAGEMENT: 'Announcement Management',

  //Sustainability Pre-Assessment Management
  SUSTAINABILITY_PRE_ASSESSMENT_MANAGEMENT:
    'Sustainability Pre-Assessment Management',
  UPLOAD_SUSTAINABILITY_PRE_ASSESSMENT_MANAGEMENT:
    'Upload Sustainability Pre-Assessment Management',

  //ESG Verification
  ESG_VERIFICATION: 'ESG Verification',

  //Comprehensive Assessment Management
  COMPREHENSIVE_ASSESSMENT_MANAGEMENT: 'Comprehensive Assessment Management',
  OFFLINE_TEMPLATE_MANAGEMENT: 'Offline Template Management',
  ONLINE_TEMPLATE_MANAGEMENT: 'Online Template Management',
  SUPPLIER_ONLINE_COMPREHENSIVE_ASSESSMENT_MANAGEMENT:
    'Online Comprehensive Assessment Management',

  //Risk Score Management
  RISK_MANAGEMENT: 'Risk Level Management',

  // Auction
  AUCTION_DASHBOARD: 'Auction Dashboard',

  //News
  RELEVANT: 'Relevant',
  INDUSTRY: 'Industry',

  // Popup
  COMPANY_ADDRESS: 'Company Address',
  COMPANY_DETAIL: 'Contact Details',
  FULL_NAME: 'Full Name',

  INTEGER: 'Please input an integer',
  DECIMAL: 'Please input number with two decimal',

  EDIT_SUPPLIER: 'Edit Supplier',
  OFFLINE_COMPREHENSIVE_ASSESSMENT_SCORE:
    'Offline Comprehensive Assessment Score',
  ONLINE_COMPREHENSIVE_ASSESSMENT_SCORE:
    'Online Comprehensive Assessment Score',
  INVITATION_DATE: 'Invitation Date',
  REGISTERED_DATE: 'Registered Date',

  //DROPDOWN
  UPDATE_DATE_DESC: 'Update Date (DESC)',
  UPDATE_DATE_ASC: 'Update Date (ASC)',
  RISK_LEVEL_DESC: 'Risk Level (DESC)',
  RISK_LEVEL_ASC: 'Risk Level (ASC)',

  SHOW_SUPPLIER: 'Show Supplier',
  ACTIVE: 'Active',

  COMPANY_REF: 'Supplier No.',

  //DateTime ago
  SECONDS_AGO: 'seconds Ago',
  MINUTES_AGO: 'minutes Ago',
  HOURS_AGO: 'hours Ago',
  DAYS_AGO: 'days Ago',
  MONTHS_AGO: 'months Ago',
  YEARS_AGO: 'years Ago',

  //Tips And Tutorial
  ENGLISH_AUCTION: 'English Auction',
  RFQ: 'RFQ',
  TIPS_AND_TUTORIAL: 'User Guideline',
  ENGLISH_AUCTION_TUTORIAL: 'English Auction Tutorial',
  RFQ_TUTORIAL: 'RFQ Tutorial',
}
